import { useTranslation } from 'react-i18next'
import { X } from 'lucide-react'
import { Dialog, DialogContent, DialogTitle } from '../dialog'
import { PreferencesShell } from '../../common/preferences/PreferencesShell'
import './PreferencesDialog.scss'
import type { PreferencesTarget } from '@/src/shared/preferencesNav'

interface PreferencesDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  /** Gleich auf dieser Seite öffnen statt auf der zuletzt gezeigten. */
  target?: PreferencesTarget
}

/**
 * Web-modal host for the Preferences UI. Renders {@link PreferencesShell}
 * inside a Radix Dialog. The shell already provides its own TopNav (which
 * doubles as the visual title), so the Dialog header is dropped — a
 * visually-hidden title still ships for screen readers.
 *
 * Counterpart for Electron: {@link PreferencesPage} (separate window).
 */
export function PreferencesDialog({ open, onOpenChange, target }: PreferencesDialogProps) {
  const { t } = useTranslation()

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent hideCloseButton className="preferences-dialog-content">
        <div className="preferences-dialog__titlebar">
          <DialogTitle className="preferences-dialog__title">{t('settings.title')}</DialogTitle>
          <button
            type="button"
            className="preferences-dialog__close"
            onClick={() => onOpenChange(false)}
            aria-label={t('settings.close')}
          >
            <X size={18} />
          </button>
        </div>
        <div className="preferences-dialog__body">
          <PreferencesShell platform="web" initialTarget={target} />
        </div>
      </DialogContent>
    </Dialog>
  )
}
